module.exports={
	"Form": "ProjectViewManifest",
	"Scope": "Project-View",
	"Descriptors":
	{
		"ProjectDetails.IDProject":
		{
			"Name": "Project ID",
			"Hash": "ProjectView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ProjectIdentity",
				"Group": "ProjectIdentity"
			}
		},
		"ProjectDetails.GUIDProject":
		{
			"Name": "GUID",
			"Hash": "ProjectView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ProjectIdentity",
				"Group": "ProjectIdentity"
			}
		},
		"ProjectDetails.Name":
		{
			"Name": "Project Name",
			"Hash": "ProjectView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ProjectIdentity",
				"Group": "ProjectIdentity"
			}
		},
		"ProjectDetails.Status":
		{
			"Name": "Status",
			"Hash": "ProjectView-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "ProjectConfig",
				"Group": "ProjectConfig"
			}
		},
		"ProjectDetails.ExternalProjectID":
		{
			"Name": "External Project ID",
			"Hash": "ProjectView-ExternalID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "ProjectConfig",
				"Group": "ProjectConfig"
			}
		},
		"ProjectDetails.IDOrganization":
		{
			"Name": "Organization ID",
			"Hash": "ProjectView-IDOrganization",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "ProjectConfig",
				"Group": "ProjectConfig"
			}
		},
		"ProjectDetails.IDContract":
		{
			"Name": "Contract ID",
			"Hash": "ProjectView-IDContract",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "ProjectConfig",
				"Group": "ProjectConfig"
			}
		},
		"ProjectDetails.Description":
		{
			"Name": "Description",
			"Hash": "ProjectView-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "ProjectDescription",
				"Group": "ProjectDescription"
			}
		},
		"ProjectDetails.CustomProperties":
		{
			"Name": "Custom Properties (JSON)",
			"Hash": "ProjectView-CustomProperties",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 12,
				"Section": "ProjectCustomProperties",
				"Group": "ProjectCustomProperties"
			}
		},
		"ProjectDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ProjectView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 3,
				"Section": "ProjectAudit",
				"Group": "ProjectAudit"
			}
		},
		"ProjectDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ProjectView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 3,
				"Section": "ProjectAudit",
				"Group": "ProjectAudit"
			}
		},
		"ProjectDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ProjectView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 3,
				"Section": "ProjectAudit",
				"Group": "ProjectAudit"
			}
		},
		"ProjectDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ProjectView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 3,
				"Section": "ProjectAudit",
				"Group": "ProjectAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProjectIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProjectIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "ProjectConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "ProjectConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Description",
			"Hash": "ProjectDescription",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Description",
					"Hash": "ProjectDescription",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Custom Properties",
			"Hash": "ProjectCustomProperties",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Custom Properties",
					"Hash": "ProjectCustomProperties",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ProjectAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ProjectAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
